import ProductsSliderPresenter from "../components/products-slider/presenter/products-slider";

const wrappers = document.querySelectorAll(`.products-list-wrapper`);

Array.from(wrappers).forEach((wrapper) => {
  const productsSliderComponent = new ProductsSliderPresenter(wrapper);
  productsSliderComponent.init();
});
